import React from "react";
import {withTranslation} from "react-i18next";
import ResultContentList from "./ResultContentList";
import DatetimeContainer from "../date/DatetimeContainer";
import CountDownTimer from "../timer/CountDownTimer";
import {getShortBetType} from "../../utils/tickets/printUtils";
import SweetAlert from "react-bootstrap-sweetalert";
import BettingDialog from "../lotto5/BettingDialog";
import {env} from "../../env";
import LoadingGif from "../../utils/LoadingGif";
import {useLotto6} from "../../store/lotto6/Lotto6Context";
import {jackpotNum} from "../../constants/general";

const DrawingResult = ({t}) => {
    const lotto = useLotto6();
    const {
        countDownTimer,
        newResult,
        lastResult,
        config: {lotto6Config},
        oldResult,
        classNameNumberDraw,
        classNameLogoRender,
        indexResultItem,
        resultItem,
        winUnderOver,
        winOddEven,
        winRange,
        winRangeLine,
        winRangeLineOne,
        isShowValidateBalance,
        allNumbers,
        totalResult,
        classCountDown,
        messageValidateBalance,
        jackpot,
        onBetting,
        changeBetAmount,
        clickAmountBetBtn,
        onConfirmBetting,
        resetDefaultAmount,
        onCancelBetting,
        isDisabledODEO,
        getOECode,
        isOE,
        pfType999,
        onCloseValidateBalance
    } = lotto;

    const {drawLabel, result, underOverCode, oddEvenCode, number} = lastResult || {};
    const platformType = env.PLATFORM_TYPE;
    const jp = oldResult?.jackpot;
    const sizeLoading = pfType999 ? "30" : "25vw";

    return <div className="row m-0">
        <div className="col-4 no-padding-div">

            <div className="col header header-div-title header-text fade-in">
                        <span
                            className="text-white last-result-betting">{drawLabel}</span>
                {
                    (underOverCode && oddEvenCode) ?
                        <span
                            className="text-white last-result-betting fade-in">{t("labels:betPrefix." + underOverCode) + "  /   " + t("labels:betPrefix." + oddEvenCode) + "  /   " + t("labels:betPrefix." + number) + "   /   " + result}</span>
                        : <span className="text-white last-result-betting fade-in"/>
                }

            </div>

            <div
                className="col div-body-white no-padding-div-left no-padding-div-right lotto6-content-result lotto6-v2-result fade-in">
                <table
                    id="keno_result_post"
                    border="1"
                    cellPadding="0"
                    cellSpacing="0"
                    width="100%"
                >
                    <tbody>
                    <ResultContentList allNumbers={allNumbers}/>
                    </tbody>
                </table>
            </div>


        </div>

        <div className="col-8 no-padding-div">


            <div className="col header header-div-title header-text no-padding-div-left fade-in">
                        <span className="text-white last-result-betting">
                            <LoadingGif width={sizeLoading}
                                        height={sizeLoading}/> {newResult !== null ? newResult.drawLabel : t("labels:upcoming_draw")}</span>
                <span className="text-white fade-in last-result-betting"
                      id="timer-display"><DatetimeContainer/></span>
            </div>

            <div className="row m-0">

                <div className="col-3 div-body-white no-padding-div">

                    <div className="col lotto6-v2-card-count-down-logo bet-bg-logo card-border">
                        {
                            indexResultItem > 6 || indexResultItem === 0
                                ? <div
                                    className="lotto6-v2-result-time-countup-render bg-transparent fade-in"/>
                                : <div
                                    className="lotto6-v2-result-time-countup-render fade-in">{indexResultItem}</div>
                        }
                        <div
                            className={"fade-in " + classNameNumberDraw}>{resultItem}</div>
                        <div className={"fade-in " + classNameLogoRender}>

                            <img src={require(`../../assets/images/logo/${platformType}.png`)}
                                 alt="..."/>
                        </div>

                    </div>

                    <div className="col lotto6-v2-card-count-down-logo bg-count-down card-border">
                        <CountDownTimer countClass="fade-in total-result-render "
                                        totalResult={totalResult}
                                        classCountDown={classCountDown}
                                        countDownTimer={countDownTimer}
                                        tenSecondCallback={lotto.countingSecond}
                        />
                    </div>

                </div>

                <div className="col-9">
                    <div className="div-body-white row fade-in">

                        {
                            lotto6Config.slots.map((item, i) => {
                                    const isActive = jackpot === jackpotNum[item.code];
                                    const isWin = item.code === winRange;
                                    const showJackpot = isWin && isActive;
                                    let classActive = isActive && oldResult ? " bg-win " : "";
                                    const winClass = isWin ? " win-" + item.code : "";
                                    let winCl = isWin ?
                                        isActive ? " win-bg-animate" : winClass
                                        : "";
                                    const subItem = item.sub;


                                    const RenderSlot = ({onClick, item}) => {
                                        let OUWinClass = item.code === winUnderOver ? ` OU-${item.code}` : "";
                                        let OEWinClass = item.code === winOddEven ? ` OE-${item.code}` : "";
                                        const isDisabled = isDisabledODEO && (item.type === "under_over" || item.type === "odd_even")

                    return (
                        <div
                            className=" no-padding-div lotto6-box-bet lotto6-v2-bet-pricing-card pointer"
                            onClick={isDisabled ? null : onClick}>

                            <div
                                className={"lotto6-v2-slot-prefix-card lotto6-v2-card-bg-color-" + item.code + classActive + winCl + OUWinClass + OEWinClass}>
                                <h1 className={`lotto6-v2-card-type-${item.code} lotto6-v2-card-bg-color-` + item.code + winClass + OUWinClass + OEWinClass}>{item.type === "underOver" ? t("labels:betPrefix.S_" + getShortBetType(item.code)) : t("labels:betPrefix." + item.code)}</h1>
                            </div>


                            <div className="lotto6-v2-slot-value-card position-relative">
                                {showJackpot && < >
                                    <img className="lotto6-jackpot-v2-img position-absolute"
                                         src={require(`../../assets/images/jackpot/v2/${jp}.png`)}
                                         alt="__"/>
                                    <img
                                        className="lotto6-jackpot-v2-img position-absolute win-animate-border"
                                        src={require('../../assets/images/jackpot/v2/border-jackpot.png')}
                                        alt="___"/>
                                </>}
                                <div
                                    className="d-flex justify-content-center align-items-center h-100">
                                    <div>
                                        <div
                                            className="lotto6-v2-range-number">{isOE(item.code) ? getOECode(item.code) : item.rangeNumber}</div>
                                        <div
                                            className={`lotto6-v2-bet-value`}>{item.value}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                };

                                    return <div key={i}
                                                className="col-3 no-padding-div lotto6-box-bet lotto6-v2-bet-pricing-card">
                                        <RenderSlot onClick={() => onBetting(item)} item={item}/>
                                        {subItem &&
                                            <RenderSlot onClick={() => onBetting(subItem)} item={subItem}/>}
                                    </div>


                                }
                            )

                        }
                        {
                            lotto6Config.rangeLine.map((item, i) => {
                                return <div
                                    className={"col-4 no-padding-div lotto6-box-bet lotto6-v2-bet-pricing-card pointer"}
                                    key={i} onClick={() => onBetting(item)}>

                                    <div
                                        className={"lotto6-v2-slot-prefix-card lotto6-v2-card-bg-color-" + item.code + " win-" + (item.code === winRangeLine ? item.code : "") + " win36-" + (item.code === winRangeLineOne ? item.code : "")}>
                                        <h1>{t("labels:betPrefix." + item.code)}</h1>
                                    </div>

                                    <div
                                        className="lotto6-v2-slot-value-card d-flex justify-content-center align-items-center">
                                        <div>
                                            <div className="lotto6-v2-range-number">{item.rangeNumber}</div>
                                            <div className="lotto6-v2-bet-value">{item.value}</div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }


                    </div>

                </div>

            </div>


        </div>
        <BettingDialog changeBetAmount={changeBetAmount}
                       clickAmountBetBtn={clickAmountBetBtn}
                       onConfirmBettingLotto5={onConfirmBetting}
                       resetDefaultAmount={resetDefaultAmount}
                       onCancelBetting={onCancelBetting}
                       {...lotto}/>

        <SweetAlert
            title={messageValidateBalance !== null ? messageValidateBalance : "message"}
            show={isShowValidateBalance}
            onConfirm={onCloseValidateBalance}
            confirmBtnText={t("labels:common.okay")}
            showCancel={false}
            btnSize="lg"
            confirmBtnBsStyle="warning"
        />

    </div>
};

export default withTranslation()(DrawingResult);
